module.exports = __webpack_public_path__ + "media/assets/images/logos/wildix_logo-6f9e6256ee955adfecf6023be984b180.png";